import React from 'react';

import { Title, ButtonsGroup, Button, Input } from 'components/commons';
import { Form, Field } from 'components/form-validation';
import { resposibleInfoSchema } from 'validation-schemas/direto';
import { LoanApplication, LoanApplicationInput } from 'generated/graphql';
import { IStepInfo } from 'providers/profile.config';


type ResponsibleInfoProps = {
    initialValue: LoanApplication;
    loading?: boolean;
    stepInfo: IStepInfo;
    screenProfile: 'default' | 'partners';
    onSubmit(LoanApplication: LoanApplicationInput): void;
    onBack(): void;
};

const ResponsibleInfoLayout: React.FC<ResponsibleInfoProps> = ({
    initialValue,
    stepInfo,
    onSubmit,
    onBack,
}) => (
    <div className="normal-screen">
        <Form
            schema={resposibleInfoSchema}
            initialValues={initialValue}
            onSubmit={onSubmit}
            render={({ valid }) => (
                <>
                    <Title className="mb-5">
                        <span
                            dangerouslySetInnerHTML={{ __html: stepInfo.title }}
                        />
                    </Title>

                    <Field
                        component={Input}
                        placeholder="Nome Completo"
                        name="borrower.responsibleName"
                        maxLength={100}
                        id="user_name"
                    />

                    <Field
                        component={Input}
                        placeholder="E-mail"
                        name="borrower.email"
                        type="email"
                        maxLength={254}
                        id="user_email"
                    />

                    <div className="fields-inline">
                        <Field
                            component={Input}
                            placeholder="CPF"
                            name="borrower.responsibleDocument"
                            mask="cpf"
                            id="user_id"
                        />
                        <Field
                            component={Input}
                            placeholder="Celular com DDD"
                            name="borrower.phone"
                            mask="phone"
                            sendRawValue
                            id="user_phone"
                        />
                    </div>

                    <ButtonsGroup>
                        <Button
                            label="voltar"
                            variant="secondary"
                            onClick={onBack}
                            data-category="Navegação Direto"
                            data-action="Clique Voltar"
                            data-label="Voltar /pedido/dados-pessoais"
                        />
                        <Button
                            label="continuar"
                            disabled={!valid}
                            type="submit"
                        />
                    </ButtonsGroup>
                </>
            )}
        />
    </div>
);

export default ResponsibleInfoLayout;
